import emailjs from 'emailjs-com';


export const validateForm = (formData) => {
  const errors = {};
  
  if (!formData.name) errors.name = 'Name is required';
  if (!formData.phoneNumber) errors.phoneNumber = 'Phone Number is required';
  if (!formData.email) errors.email = 'Email is required';
  if (!formData.labName) errors.labName = 'Lab Name is required';
  
  return errors;
};

export const submitFormData = async (formData) => {
  return emailjs.send(
    'service_dpwsw2j',    // Replace with your EmailJS Service ID
    'template_ktx5ff9',   // Replace with your EmailJS Template ID
    {
      name: formData.name,
      phone_number: formData.phoneNumber,
      email: formData.email,
      lab_name: formData.labName,
    },
    '3z07ZkeWTz2Up-5HM'   // Replace with your EmailJS Public Key
  );
};